export class PaginationAndSortRequest {
    public startLimit: number;
    public endLimit: number;
    public sortBy: string;
    public sortType: string;   
    public searchKey: string;

}